const sentinalEl = document.querySelector('.l-header-top');
if (sentinalEl) {
	const handler = (entries) => {
		const stickyClass = 'has-sticky-header';

		if (!entries[0].isIntersecting) {
			document.body.classList.add(stickyClass);
		} else {
			document.body.classList.remove(stickyClass);
		}
	}

	const observer = new window.IntersectionObserver(handler);
	observer.observe(sentinalEl);
}
